<template>
    <div class="kpi-container">
        <!-- 固定头部 -->
        <div class="fixed-header">
            <Header
                :showHeaderArrow="false"
                :showChoice="true"
                :showchange="true"
                @changeorg="changeorg"
            >
                <template #title>
                    <div class="page-header">
                        <h1 class="page-title">绩效考核表模板</h1>
                        <p class="page-subtitle">管理和分配团队绩效考核模板</p>
                    </div>
                </template>
            </Header>

            <!-- 操作栏 -->
            <div class="action-bar">
                <div class="action-left">
                    <!-- v-if="myRole !== '1'" -->
                    <el-button
                        type="primary"
                        @click="gotomykpidetail"
                    >
                        <el-icon><User /></el-icon>
                        我的KPI
                    </el-button>
                    <el-button
                        type="success"
                        @click="rentoall"
                    >
                        <el-icon><View /></el-icon>
                        成员KPI
                    </el-button>
                    <el-button
                        v-if="myRole === '1'"
                        type="success"
                        @click="rentoall('ml')"
                    >
                        <el-icon><View /></el-icon>
                        全部KPI
                    </el-button>
                    <el-button
                        type="info"
                        plain
                        @click="Router.push('/usage-guide')"
                    >
                        <el-icon><Document /></el-icon>
                        操作手册
                    </el-button>
                </div>

                <el-radio-group
                    v-model="mouth"
                    size="default"
                    @change="rentuermouth"
                >
                    <el-radio-button :label="1">
                        {{ getMonthDisplay(previousMonth) }}
                    </el-radio-button>
                    <el-radio-button :label="2">
                        {{ getMonthDisplay(currentMonth) }}
                    </el-radio-button>
                </el-radio-group>
            </div>
        </div>

        <!-- 可滚动内容区域 -->
        <div class="scroll-content">
            <!-- 加载状态 -->
            <div
                v-if="listloading"
                class="loading-grid"
            >
                <div
                    v-for="i in 6"
                    :key="i"
                    class="skeleton-card"
                >
                    <el-skeleton
                        :rows="3"
                        animated
                    />
                </div>
            </div>

            <!-- 模板卡片网格 -->
            <transition-group
                v-else-if="list?.length"
                name="card"
                tag="div"
                class="template-grid"
            >
                <div
                    v-for="(item, index) in list"
                    :key="item.id"
                    class="template-card"
                    @click="gotodetail(item)"
                >
                    <!-- 卡片头部 -->
                    <div class="card-header">
                        <div class="header-left">
                            <div class="template-icon">
                                <el-icon><Document /></el-icon>
                            </div>
                            <div class="header-info">
                                <div
                                    v-if="!item.isEditing"
                                    class="title-wrapper"
                                >
                                    <h3
                                        class="card-title"
                                        :title="item.title"
                                    >
                                        {{ item.title || `模板 ${index + 1}` }}
                                    </h3>
                                </div>
                                <div
                                    v-else
                                    class="title-edit"
                                    @click.stop
                                >
                                    <el-input
                                        v-model="item.editingTitle"
                                        placeholder="输入模板标题"
                                        @keyup.enter="saveEdit(item)"
                                        @blur="saveEdit(item)"
                                        size="small"
                                    />
                                </div>
                                <div class="card-meta">
                                    <span class="meta-item">
                                        <el-icon><Calendar /></el-icon>
                                        {{ item.createDateTime?.split(" ")[0] || select }}
                                    </span>
                                    <button
                                        v-if="!item.isEditing"
                                        class="edit-btn"
                                        @click.stop="startEdit(item)"
                                    >
                                        <el-icon size="12"><Edit /></el-icon>
                                        重命名
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="header-actions">
                            <el-tooltip content="复制模板">
                                <button
                                    class="action-btn copy"
                                    @click.stop="plustem(item, index)"
                                >
                                    <el-icon><CopyDocument /></el-icon>
                                </button>
                            </el-tooltip>
                            <el-tooltip content="删除模板">
                                <button
                                    class="action-btn delete"
                                    @click.stop="deletetem(item, index)"
                                >
                                    <el-icon><Delete /></el-icon>
                                </button>
                            </el-tooltip>
                        </div>
                    </div>

                    <!-- 卡片内容 -->
                    <div
                        class="card-body"
                        @click.stop
                    >
                        <div class="members-inline">
                            <div class="members-inline-header">
                                <el-icon
                                    size="14"
                                    color="#16a34a"
                                >
                                    <UserFilled />
                                </el-icon>
                                <span class="members-inline-label">成员</span>
                                <el-tag
                                    size="small"
                                    type="info"
                                >
                                    {{ item.list?.length || 0 }}人
                                </el-tag>
                            </div>
                            <div
                                v-if="item.list?.length"
                                class="members-inline-tags"
                            >
                                <div
                                    v-for="member in item.list.slice(0, 6)"
                                    :key="member.value"
                                    class="member-tag-inline"
                                    :class="`theme-${getRandomType(member.value)}`"
                                >
                                    <span
                                        class="member-avatar"
                                        :class="`avatar-${getRandomType(member.value)}`"
                                    >
                                        {{ member.label?.charAt(0) || "?" }}
                                    </span>
                                    <span class="member-name">{{ member.label }}</span>
                                </div>
                                <el-popover
                                    v-if="item.list.length > 6"
                                    placement="top"
                                    :width="320"
                                    trigger="hover"
                                    popper-class="members-popover"
                                >
                                    <template #reference>
                                        <div class="member-tag-inline more-tag">
                                            +{{ item.list.length - 6 }}
                                        </div>
                                    </template>
                                    <div class="members-popover-content">
                                        <div class="popover-header">
                                            <span class="popover-title">全部成员</span>
                                            <el-tag
                                                size="small"
                                                type="info"
                                            >
                                                {{ item.list.length }}人
                                            </el-tag>
                                        </div>
                                        <div class="members-grid-simple">
                                            <div
                                                v-for="member in item.list"
                                                :key="member.value"
                                                class="member-tag"
                                                :class="`theme-${getRandomType(member.value)}`"
                                            >
                                                {{ member.label }}
                                            </div>
                                        </div>
                                    </div>
                                </el-popover>
                            </div>
                            <div
                                v-else
                                class="members-inline-empty"
                            >
                                暂未分配成员
                            </div>
                        </div>
                    </div>

                    <!-- 卡片底部 -->
                    <div class="card-footer">
                        <el-button
                            type="default"
                            size="small"
                            @click.stop="openAssignDialog(item)"
                        >
                            <el-icon><Setting /></el-icon>
                            分配成员
                        </el-button>

                        <el-button
                            type="primary"
                            size="small"
                            plain
                        >
                            <el-icon><View /></el-icon>
                            查看详情
                        </el-button>
                    </div>
                </div>
            </transition-group>

            <!-- 空状态 -->
            <el-empty
                v-else
                description="暂无模板数据"
                :image-size="180"
            >
                <el-button
                    type="primary"
                    size="large"
                    @click="createTemplate"
                >
                    <el-icon><Plus /></el-icon>
                    创建第一个模板
                </el-button>
            </el-empty>
        </div>

        <!-- 分配成员弹窗 -->
        <el-dialog
            v-model="assignDialogVisible"
            title="选择成员"
            width="500px"
            :close-on-click-modal="false"
            class="assign-dialog"
        >
            <div class="dialog-content">
                <el-select
                    v-model="selectedMembers"
                    collapse-tags
                    collapse-tags-tooltip
                    placeholder="请选择成员"
                    size="large"
                    clearable
                    multiple
                    filterable
                    class="member-select"
                    :loading="memberLoading"
                >
                    <el-option
                        v-for="v in memberOptions"
                        :key="v.value"
                        :label="v.label"
                        :value="v.value"
                    >
                        <div class="option-item">
                            <!-- <div class="option-avatar" :class="`theme-${getRandomType(v.value)}`">
                                {{ v.label?.charAt(0) || 'U' }}
                            </div> -->
                            <div class="option-info">
                                <span class="option-name">{{ v.label }}</span>
                                <!-- <span class="option-id">ID: {{ v.value }}</span> -->
                            </div>
                        </div>
                    </el-option>
                </el-select>

                <!-- 已选成员预览 -->
                <div
                    v-if="selectedMembers?.length"
                    class="selected-preview"
                >
                    <div class="preview-header">
                        <span>已选成员 ({{ selectedMembers.length }})</span>
                        <el-button
                            text
                            size="small"
                            @click="selectedMembers = []"
                        >
                            清空
                        </el-button>
                    </div>
                    <div class="preview-tags">
                        <el-tag
                            v-for="id in selectedMembers"
                            :key="id"
                            closable
                            @close="removeSelectedMember(id)"
                            class="preview-tag"
                        >
                            {{ getMemberName(id) }}
                        </el-tag>
                    </div>
                </div>
            </div>

            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="assignDialogVisible = false">取消</el-button>
                    <el-button
                        type="primary"
                        @click="confirmAssign"
                        :loading="assignLoading"
                        :disabled="!selectedMembers?.length"
                    >
                        确定分配
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { getCurrentAndPreviousMonth } from "@/utils/data";
import Header from "@/components/mainHeader.vue";
import {
    findlistAll,
    addtemplateAll,
    deletetemplateAPI,
    userlistAPI,
    userissuedAPI,
    updateTemplateTitle
} from "@/api/api";
import {
    ElSelect,
    ElOption,
    ElButton,
    ElIcon,
    ElMessage,
    ElMessageBox,
    ElEmpty,
    ElRadioGroup,
    ElRadioButton,
    ElInput,
    ElTooltip,
    ElSkeleton,
    ElTag,
    ElDialog,
    ElPopover
} from "element-plus";
import {
    View,
    Plus,
    Delete,
    Setting,
    User,
    Edit,
    UserFilled,
    Calendar,
    CopyDocument,
    Close,
    Document,
    Tickets
} from "@element-plus/icons-vue";

const Router = useRouter();
const Route = useRoute();
const list = ref([]);
const myRole = ref(localStorage.getItem("role"));
const mouth = ref(1);
const listloading = ref(true);
const select = ref();

// 将 "2026-03" 转成 "3月"
const getMonthDisplay = (monthStr) => {
    if (!monthStr) return "";
    const month = parseInt(monthStr.split("-")[1]);
    return `${month}月`;
};

// 分配弹窗相关
const assignDialogVisible = ref(false);
const currentTemplate = ref(null);
const selectedMembers = ref([]);
const memberOptions = ref([]);
const memberLoading = ref(false);
const assignLoading = ref(false);

const { currentMonth, previousMonth } = getCurrentAndPreviousMonth();

const tagTypes = ["1", "2", "3", "4", "5"];
const getRandomType = (value) => {
    const str = value?.toString() || "0";
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return tagTypes[Math.abs(hash) % tagTypes.length];
};

// 从路由参数读取月份，如果没有则默认为 1（上月）
const initMonthFromRoute = () => {
    const routeMonth = Route.query.month;
    if (routeMonth) {
        mouth.value = Number(routeMonth);
        select.value = Number(routeMonth) === 1 ? previousMonth : currentMonth;
    } else {
        // 如果没有路由参数，默认显示上月，并更新路由
        mouth.value = 1;
        select.value = previousMonth;
        Router.replace({
            path: Route.path,
            query: {
                ...Route.query,
                month: 1
            }
        });
    }
};

// 初始化月份
initMonthFromRoute();

const rentuermouth = (v) => {
    mouth.value = v;
    select.value = v === 1 ? previousMonth : currentMonth;
    // 更新路由参数而不是 localStorage
    Router.replace({
        path: Route.path,
        query: {
            ...Route.query,
            month: v
        }
    });
    findlist();
};

const findlist = () => {
    listloading.value = true;
    const data = { date: select.value };

    findlistAll(data)
        .then((res) => {
            if (res.code === "8200") {
                list.value = res.data.map((item) => ({
                    ...item,
                    isEditing: false
                }));
            }
        })
        .finally(() => {
            listloading.value = false;
        });
};

// 打开分配弹窗
const openAssignDialog = (item) => {
    currentTemplate.value = item;
    selectedMembers.value = [];
    memberLoading.value = true;
    assignDialogVisible.value = true;

    userlistAPI({ templateId: item.id })
        .then((res) => {
            if (res.code === "8200") {
                memberOptions.value = [
                    { value: "0", label: "全部成员" },
                    ...res?.data?.map((user) => ({
                        value: user.id,
                        label: user.nickname
                    }))
                ];
            }
        })
        .catch(() => {
            ElMessage.error("获取成员列表失败");
        })
        .finally(() => {
            memberLoading.value = false;
        });
};

// 确认分配
const confirmAssign = () => {
    if (!selectedMembers.value?.length) {
        ElMessage.warning("请选择成员");
        return;
    }

    assignLoading.value = true;
    const data = {
        ids: selectedMembers.value,
        templateId: currentTemplate.value.id,
        date: select.value
    };

    userissuedAPI(data)
        .then((res) => {
            if (res?.data) {
                ElMessage.success("分配成功");

                // 更新当前模板的成员列表
                const newMembers = memberOptions.value.filter(
                    (item) => selectedMembers.value.includes(item.value) && item.value !== "0"
                );

                const existingValues = new Set(
                    currentTemplate.value.list?.map((m) => m.value) || []
                );
                const uniqueNewMembers = newMembers.filter((m) => !existingValues.has(m.value));

                currentTemplate.value.list = [
                    ...(currentTemplate.value.list || []),
                    ...uniqueNewMembers
                ];

                // 关闭弹窗
                assignDialogVisible.value = false;
                selectedMembers.value = [];
            }
        })
        .catch(() => {
            ElMessage.error("分配失败");
        })
        .finally(() => {
            assignLoading.value = false;
        });
};

// 移除已选成员
const removeSelectedMember = (id) => {
    const index = selectedMembers.value.indexOf(id);
    if (index > -1) {
        selectedMembers.value.splice(index, 1);
    }
};

// 获取成员名称
const getMemberName = (id) => {
    const member = memberOptions.value.find((m) => m.value === id);
    return member?.label || id;
};

// 移除成员
const removeMember = (item, member) => {
    ElMessageBox.confirm("确定要移除该成员吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
    })
        .then(() => {
            const index = item.list.findIndex((m) => m.value === member.value);
            if (index > -1) {
                item.list.splice(index, 1);
                ElMessage.success("移除成功");
            }
        })
        .catch(() => {});
};

// 删除模板
const deletetem = (v, index) => {
    ElMessageBox.confirm("确定要删除此模板吗？删除后无法恢复。", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
    })
        .then(() => {
            const data = { id: v.id };
            deletetemplateAPI(data)
                .then((res) => {
                    if (res?.code === "8200") {
                        list.value.splice(index, 1);
                        ElMessage.success("删除成功");
                    }
                })
                .catch(() => {
                    ElMessage.error("删除失败");
                });
        })
        .catch(() => {});
};

// 复制模板
const plustem = (v, index) => {
    const Formdata = new FormData();
    Formdata.append("id", v.id);
    Formdata.append("date", select.value);

    addtemplateAll(Formdata)
        .then((res) => {
            if (res?.data) {
                ElMessage.success("复制成功");
                findlist();
            }
        })
        .catch(() => {
            ElMessage.error("复制失败");
        });
};

// 开始编辑标题
const startEdit = (item) => {
    item.isEditing = true;
    item.editingTitle = item.title;
};

// 保存编辑
const saveEdit = (item) => {
    if (!item.editingTitle?.trim()) {
        ElMessage.warning("标题不能为空");
        item.editingTitle = item.title;
        item.isEditing = false;
        return;
    }

    const data = {
        id: item.id,
        title: item.editingTitle.trim()
    };

    updateTemplateTitle(data)
        .then((res) => {
            if (res.code === "8200") {
                item.title = item.editingTitle.trim();
                ElMessage.success("修改成功");
            }
        })
        .catch(() => {
            ElMessage.error("修改失败");
        })
        .finally(() => {
            item.isEditing = false;
        });
};

// 页面跳转
const gotodetail = (v) => {
    Router.push({
        path: "/detail",
        query: { id: v.id, type: 0 }
    });
};

const gotomykpidetail = () => {
    Router.push({ path: "/detail" });
};

const rentoall = (v) => {
    if (v === "ml") {
        Router.push({ path: "/all", query: { type: "ml", month: Route.query.month } });
    } else {
        Router.push({ path: "/all", query: { month: Route.query.month } });
    }
};

const createTemplate = () => {
    plustem({ id: 179 });
    // ElMessage.info("创建模板功能开发中...");
};

const changeorg = () => {
    findlist();
};

// 监听路由变化，当月份参数变化时更新数据
watch(
    () => Route.query.month,
    (newMonth) => {
        if (newMonth) {
            const monthNum = Number(newMonth);
            if (monthNum !== mouth.value) {
                mouth.value = monthNum;
                select.value = monthNum === 1 ? previousMonth : currentMonth;
                findlist();
            }
        }
    }
);

// 初始化
findlist();
</script>

<style lang="scss" scoped>
// 容器布局
.kpi-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #f0f2f5;
    overflow: hidden;
}

// 固定头部
.fixed-header {
    flex-shrink: 0;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    z-index: 100;
}

.page-header {
    padding: 16px 24px;

    .page-title {
        margin: 0 0 4px 0;
        font-size: 24px;
        font-weight: 600;
        color: #303133;
    }

    .page-subtitle {
        margin: 0;
        font-size: 13px;
        color: #909399;
    }
}

.action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px;
    border-top: 1px solid #f0f2f5;

    .action-left {
        display: flex;
        gap: 10px;
    }
}

// 可滚动内容区
.scroll-content {
    flex: 1;
    overflow-y: auto;
    padding: 24px;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f0f2f5;
    }

    &::-webkit-scrollbar-thumb {
        background: #c0c4cc;
        border-radius: 4px;

        &:hover {
            background: #909399;
        }
    }
}

// 加载骨架屏
.loading-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;

    .skeleton-card {
        background: white;
        padding: 20px;
        border-radius: 16px;
    }
}

// 模板网格 - 更紧凑
.template-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
    margin-bottom: 24px;
}

// 模板卡片
.template-card {
    background: white;
    border-radius: 14px;
    overflow: hidden;
    border: 1px solid #e8ecf1;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.1);
        border-color: #d0d5dd;

        .action-btn {
            opacity: 1;
        }
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: linear-gradient(90deg, #18b984 0%, #34d399 100%);
        transform: scaleX(0);
        transition: transform 0.3s ease;
    }

    &:hover::before {
        transform: scaleX(1);
    }
}

// 卡片头部
.card-header {
    padding: 16px 20px;
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid #f0f2f5;
    position: relative;

    .header-left {
        display: flex;
        gap: 12px;
        flex: 1;
        min-width: 0;
    }

    .template-icon {
        width: 42px;
        height: 42px;
        border-radius: 10px;
        background: #f0fdf4;
        border: 1px solid #bbf7d0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #16a34a;
        font-size: 20px;
        flex-shrink: 0;
    }

    .header-info {
        flex: 1;
        min-width: 0;
    }

    .title-wrapper {
        display: flex;
        align-items: flex-start;
        gap: 6px;
        margin-bottom: 4px;
    }

    .card-title {
        margin: 0;
        font-size: 15px;
        font-weight: 600;
        color: #1a1a1a;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
        flex: 1;
    }

    .edit-btn {
        border: none;
        background: transparent;
        color: #b0b3b8;
        cursor: pointer;
        border-radius: 4px;
        display: inline-flex;
        align-items: center;
        gap: 3px;
        font-size: 12px;
        padding: 2px 6px;
        opacity: 0;
        transition: all 0.2s ease;

        &:hover {
            background: #f0f9ff;
            color: #0284c7;
        }
    }

    .header-info:hover .edit-btn {
        opacity: 1;
    }

    .title-edit {
        margin-bottom: 6px;
    }

    .card-meta {
        display: flex;
        gap: 12px;
        font-size: 12px;
        color: #909399;

        .meta-item {
            display: flex;
            align-items: center;
            gap: 4px;

            .el-icon {
                font-size: 13px;
            }
        }
    }

    .header-actions {
        display: flex;
        gap: 4px;
        position: absolute;
        right: 12px;
        top: 12px;
    }

    .action-btn {
        width: 32px;
        height: 32px;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        opacity: 0;
        flex-shrink: 0;

        .el-icon {
            font-size: 16px;
        }

        &.copy {
            background: #ecf5ff;
            color: #409eff;

            &:hover {
                background: #409eff;
                color: white;
                transform: scale(1.1);
            }
        }

        &.delete {
            background: #fef0f0;
            color: #f56c6c;

            &:hover {
                background: #f56c6c;
                color: white;
                transform: scale(1.1);
            }
        }
    }
}

// 卡片主体 - 紧凑版
.card-body {
    padding: 12px 20px;
}

.members-inline {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.members-inline-header {
    display: flex;
    align-items: center;
    gap: 6px;
}

.members-inline-label {
    font-size: 13px;
    font-weight: 600;
    color: #4a5568;
}

.members-inline-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
}

.member-tag-inline {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 10px 3px 3px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
    color: #1a1a2e;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    white-space: nowrap;
    transition: all 0.25s ease;
}

.member-tag-inline:hover {
    transform: translateY(-2px);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
}

.member-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    font-size: 11px;
    font-weight: 700;
    color: #374151;
    background: #e5e7eb;
    flex-shrink: 0;
}

.member-name {
    line-height: 1;
}

.member-tag-inline.theme-1 {
    background: #f0fdf4;
    border-color: #bbf7d0;
}
.member-tag-inline.theme-2 {
    background: #ecfeff;
    border-color: #a5f3fc;
}
.member-tag-inline.theme-3 {
    background: #f0f9ff;
    border-color: #bae6fd;
}
.member-tag-inline.theme-4 {
    background: #fefce8;
    border-color: #fde68a;
}
.member-tag-inline.theme-5 {
    background: #faf5ff;
    border-color: #e9d5ff;
}

.avatar-1 {
    background: #86efac;
    color: #14532d;
}
.avatar-2 {
    background: #a5f3fc;
    color: #164e63;
}
.avatar-3 {
    background: #bae6fd;
    color: #0c4a6e;
}
.avatar-4 {
    background: #fde68a;
    color: #713f12;
}
.avatar-5 {
    background: #e9d5ff;
    color: #581c87;
}

.member-tag-inline.more-tag {
    background: #f3f4f6;
    color: #6b7280;
    cursor: pointer;
    font-weight: 700;
    padding: 3px 12px;
    border-color: #d1d5db;
}

.member-tag-inline.more-tag:hover {
    background: #e5e7eb;
    color: #374151;
    border-color: #9ca3af;
}

.members-inline-empty {
    font-size: 12px;
    color: #9ca3af;
    padding: 4px 0;
}

// 统计网格 - 2列布局
.stats-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

// 统计卡片
.stat-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    border-radius: 12px;
    transition: all 0.3s ease;
    cursor: pointer;

    &.members-stat {
        background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);

        .stat-icon {
            background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
        }

        &:hover {
            background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(22, 163, 74, 0.2);
        }
    }

    &.tasks-stat {
        background: linear-gradient(135deg, #fce7f3 0%, #fee2e2 100%);

        .stat-icon {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
        }

        &:hover {
            background: linear-gradient(135deg, #fbcfe8 0%, #fecaca 100%);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(240, 147, 251, 0.2);
        }
    }

    .stat-icon {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 18px;
        flex-shrink: 0;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }

    .stat-content {
        flex: 1;
        min-width: 0;
    }

    .stat-value {
        font-size: 24px;
        font-weight: 700;
        color: #303133;
        line-height: 1;
        margin-bottom: 4px;
    }

    .stat-label {
        font-size: 12px;
        color: #606266;
        font-weight: 500;
    }
}

// 卡片底部
.card-footer {
    padding: 14px 20px;
    border-top: 1px solid #f0f2f5;
    display: flex;
    gap: 10px;
    background: #fafcfd;

    .el-button {
        flex: 1;
        font-weight: 500;
    }
}

// 成员气泡样式
.members-popover-content {
    .popover-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #f0f2f5;

        .popover-title {
            font-size: 14px;
            font-weight: 600;
            color: #303133;
        }
    }

    // 简化的成员网格 - 4列布局
    .members-grid-simple {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 8px;
        max-height: 320px;
        overflow-y: auto;
        padding: 2px;

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-track {
            background: #f5f7fa;
            border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c0c4cc;
            border-radius: 3px;

            &:hover {
                background: #909399;
            }
        }
    }

    // 成员标签样式
    .member-tag {
        padding: 8px 12px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 500;
        color: #000;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transition: all 0.3s ease;
        cursor: default;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
        }

        &.theme-1 {
            background: #f0fdf4;
            color: #15803d;
        }
        &.theme-2 {
            background: #ecfeff;
            color: #0e7490;
        }
        &.theme-3 {
            background: #f0f9ff;
            color: #0369a1;
        }
        &.theme-4 {
            background: #fefce8;
            color: #a16207;
        }
        &.theme-5 {
            background: #faf5ff;
            color: #7e22ce;
        }
    }

    .empty-members {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;

        .empty-icon {
            font-size: 48px;
            color: #d0d0d0;
            margin-bottom: 12px;
        }

        .empty-text {
            font-size: 14px;
            color: #909399;
            margin: 0;
        }
    }
}

// 分配弹窗样式
.assign-dialog {
    :deep(.el-dialog__header) {
        padding: 20px 24px;
        border-bottom: 1px solid #f0f2f5;
        margin-right: 0;

        .el-dialog__title {
            font-size: 18px;
            font-weight: 600;
            color: #303133;
        }
    }

    :deep(.el-dialog__body) {
        padding: 24px;
    }

    :deep(.el-dialog__footer) {
        padding: 16px 24px;
        border-top: 1px solid #f0f2f5;
    }
}

.dialog-content {
    .member-select {
        width: 100%;
        margin-bottom: 20px;

        :deep(.el-select__wrapper) {
            min-height: 44px;
            border-radius: 8px;
        }
    }

    .option-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 4px 0;

        .option-avatar {
            width: 32px;
            height: 32px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-weight: 600;
            color: white;
            flex-shrink: 0;

            &.theme-1 {
                background: #86efac;
                color: #14532d;
            }
            &.theme-2 {
                background: #a5f3fc;
                color: #164e63;
            }
            &.theme-3 {
                background: #bae6fd;
                color: #0c4a6e;
            }
            &.theme-4 {
                background: #fde68a;
                color: #713f12;
            }
            &.theme-5 {
                background: #e9d5ff;
                color: #581c87;
            }
        }

        .option-info {
            flex: 1;
            min-width: 0;

            .option-name {
                display: block;
                font-size: 14px;
                color: #303133;
                font-weight: 500;
            }

            .option-id {
                display: block;
                font-size: 12px;
                color: #909399;
                margin-top: 2px;
            }
        }
    }

    .selected-preview {
        background: #f8f9fa;
        border-radius: 8px;
        padding: 16px;

        .preview-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 12px;
            font-size: 14px;
            font-weight: 600;
            color: #606266;
        }

        .preview-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .preview-tag {
                font-size: 13px;
                padding: 6px 12px;
                border-radius: 6px;
            }
        }
    }
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    .el-button {
        padding: 10px 24px;
        border-radius: 8px;
        font-weight: 500;
    }
}

// 动画效果
.card-enter-active {
    transition: all 0.5s ease;
}

.card-leave-active {
    transition: all 0.3s ease;
}

.card-enter-from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
}

.card-leave-to {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
}

// 响应式设计
@media screen and (max-width: 1600px) {
    .template-grid {
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    }
}

@media screen and (max-width: 1200px) {
    .template-grid {
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    }

    .members-list {
        grid-template-columns: 1fr !important;
    }
}

@media screen and (max-width: 768px) {
    .fixed-header {
        .page-header {
            padding: 12px 16px;

            .page-title {
                font-size: 20px;
            }
        }

        .action-bar {
            flex-direction: column;
            gap: 12px;
            padding: 12px 16px;

            .action-left {
                width: 100%;

                .el-button {
                    flex: 1;
                }
            }

            .el-radio-group {
                width: 100%;
                display: flex;

                .el-radio-button {
                    flex: 1;
                }
            }
        }
    }

    .scroll-content {
        padding: 16px;
    }

    .template-grid,
    .loading-grid {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .template-card {
        .card-header {
            padding: 16px;

            .template-icon {
                width: 40px;
                height: 40px;
                font-size: 18px;
            }

            .card-title {
                font-size: 15px;
            }

            .action-btn {
                opacity: 1;
            }
        }

        .card-body {
            padding: 16px;
        }

        .card-footer {
            padding: 12px 16px;
            flex-direction: column;

            .el-button {
                width: 100%;
            }
        }
    }

    .stats-grid {
        grid-template-columns: 1fr;
    }

    .assign-dialog {
        :deep(.el-dialog) {
            width: 90% !important;
            margin: 0 auto;
        }
    }
}

// Element Plus 组件样式覆盖
:deep(.el-button) {
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.3s ease;

    &:active {
        transform: scale(0.96);
    }
}

:deep(.el-input__wrapper) {
    border-radius: 8px;
    box-shadow: 0 0 0 1px #dcdfe6 inset;
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 0 0 1px #c0c4cc inset;
    }

    &.is-focus {
        box-shadow: 0 0 0 1px #409eff inset !important;
    }
}

:deep(.el-select) {
    .el-select__wrapper {
        border-radius: 8px;
    }
}

:deep(.el-select-dropdown) {
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);

    .el-select-dropdown__item {
        border-radius: 6px;
        margin: 4px 8px;
        padding: 8px 12px;

        &.hover {
            background: #f5f7fa;
        }

        &.selected {
            color: #409eff;
            font-weight: 600;
            background: #ecf5ff;
        }
    }
}

:deep(.el-radio-button) {
    .el-radio-button__inner {
        border-radius: 8px;
        border: none;
        background: #f5f7fa;
        color: #606266;
        transition: all 0.3s ease;

        &:hover {
            color: #409eff;
        }
    }

    &:first-child .el-radio-button__inner {
        border-radius: 8px 0 0 8px;
    }

    &:last-child .el-radio-button__inner {
        border-radius: 0 8px 8px 0;
    }

    &.is-active .el-radio-button__inner {
        background: #409eff;
        color: white;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
    }
}

:deep(.el-tag) {
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
    }

    .el-tag__close {
        &:hover {
            background-color: rgba(0, 0, 0, 0.2);
        }
    }
}

:deep(.el-empty) {
    padding: 80px 20px;

    .el-empty__image {
        margin-bottom: 20px;
    }

    .el-empty__description {
        margin-top: 12px;
        font-size: 14px;
    }
}

:deep(.el-skeleton) {
    .el-skeleton__item {
        background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);
        background-size: 400% 100%;
        animation: skeleton-loading 1.4s ease infinite;
    }
}

@keyframes skeleton-loading {
    0% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0 50%;
    }
}

// Popover 样式定制
:deep(.el-popover.members-popover) {
    padding: 16px;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

// 工具提示
:deep(.el-tooltip__popper) {
    border-radius: 6px;
    font-size: 12px;
    padding: 8px 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

// 消息提示
:deep(.el-message) {
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    min-width: 320px;
    padding: 14px 20px;

    .el-message__content {
        font-size: 14px;
    }
}

// 确认框
:deep(.el-message-box) {
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);

    .el-message-box__header {
        padding: 20px 20px 12px;
    }

    .el-message-box__title {
        font-size: 16px;
        font-weight: 600;
    }

    .el-message-box__content {
        padding: 12px 20px;
        font-size: 14px;
        line-height: 1.6;
    }

    .el-message-box__btns {
        padding: 12px 20px 20px;

        .el-button {
            border-radius: 8px;
            padding: 10px 20px;
        }
    }
}

// 对话框动画
:deep(.el-dialog) {
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    animation: dialogFadeIn 0.3s ease-out;
}

@keyframes dialogFadeIn {
    from {
        opacity: 0;
        transform: scale(0.9) translateY(-20px);
    }
    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

:deep(.el-overlay) {
    backdrop-filter: blur(4px);
}

// 滚动行为优化
.scroll-content {
    scroll-behavior: smooth;
}

// 打印样式
@media print {
    .fixed-header {
        position: static;
    }

    .action-bar,
    .header-actions,
    .card-footer {
        display: none !important;
    }

    .scroll-content {
        overflow: visible;
        padding: 0;
    }

    .template-grid {
        display: block;
    }

    .template-card {
        break-inside: avoid;
        page-break-inside: avoid;
        margin-bottom: 20px;
        box-shadow: none;
        border: 1px solid #ddd;

        &:hover {
            transform: none;
            box-shadow: none;
        }
    }
}

// 深色模式
@media (prefers-color-scheme: dark) {
    .kpi-container {
        background: #0f0f0f;
    }

    .fixed-header {
        background: #1a1a1a;
        border-bottom: 1px solid #2a2a2a;
    }

    .action-bar {
        border-top-color: #2a2a2a;
    }

    .page-title,
    .card-title {
        color: #e0e0e0;
    }

    .page-subtitle,
    .card-meta {
        color: #a0a0a0;
    }

    .template-card {
        background: #1a1a1a;
        border: 1px solid #2a2a2a;
    }

    .card-header {
        border-bottom-color: #2a2a2a;
    }

    .card-footer {
        background: #141414;
        border-top-color: #2a2a2a;
    }

    .stat-card {
        &.members-stat {
            background: linear-gradient(135deg, #064e3b 0%, #065f46 100%);
        }

        &.tasks-stat {
            background: linear-gradient(135deg, #164e63 0%, #155e75 100%);
        }

        .stat-value {
            color: #e0e0e0;
        }

        .stat-label {
            color: #a0a0a0;
        }
    }

    .members-popover-content {
        .popover-title {
            color: #e0e0e0;
        }

        .member-item {
            background: #252525;

            &:hover {
                background: #2a2a2a;
            }

            .member-name {
                color: #e0e0e0;
            }

            .member-id {
                color: #808080;
            }
        }

        .empty-icon {
            color: #404040;
        }

        .empty-text {
            color: #808080;
        }
    }

    .dialog-content {
        .selected-preview {
            background: #252525;
        }
    }

    :deep(.el-dialog) {
        background: #1a1a1a;
        border: 1px solid #2a2a2a;

        .el-dialog__header {
            border-bottom-color: #2a2a2a;

            .el-dialog__title {
                color: #e0e0e0;
            }
        }

        .el-dialog__footer {
            border-top-color: #2a2a2a;
        }
    }

    :deep(.el-popover.members-popover) {
        background: #1a1a1a;
        border: 1px solid #2a2a2a;
    }

    :deep(.el-input__wrapper) {
        background: #252525;
        box-shadow: 0 0 0 1px #2a2a2a inset;

        &:hover {
            box-shadow: 0 0 0 1px #404040 inset;
        }

        &.is-focus {
            box-shadow: 0 0 0 1px #409eff inset !important;
        }
    }

    :deep(.el-select-dropdown) {
        background: #1a1a1a;
        border-color: #2a2a2a;

        .el-select-dropdown__item {
            color: #e0e0e0;

            &.hover {
                background: #252525;
            }

            &.selected {
                background: rgba(64, 158, 255, 0.2);
            }
        }
    }
}

// 高对比度模式
@media (prefers-contrast: high) {
    .template-card {
        border: 2px solid currentColor;
    }

    .stat-card {
        border: 1px solid currentColor;
    }

    .action-btn {
        border: 2px solid currentColor;
    }
}

// 减少动画
@media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
        scroll-behavior: auto !important;
    }
}

// 性能优化
.template-card {
    will-change: transform;
    contain: layout style paint;
}

.stat-card {
    will-change: transform;
}

// 触摸设备优化
@media (hover: none) and (pointer: coarse) {
    .template-card {
        &:active {
            transform: scale(0.98);
        }
    }

    .action-btn,
    .edit-btn {
        opacity: 1 !important;
    }

    .member-remove {
        opacity: 1 !important;
    }
}

// 卡片序列动画
@for $i from 1 through 20 {
    .template-card:nth-child(#{$i}) {
        animation-delay: #{$i * 0.05}s;
    }
}

// 卡片进入视口动画
@keyframes slideInUp {
    from {
        opacity: 0;
        transform: translateY(40px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.template-card {
    animation: slideInUp 0.6s ease-out backwards;
}

// 统计数字滚动效果
@keyframes countUp {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.stat-value {
    animation: countUp 0.5s ease-out;
}

// 焦点可见性增强
*:focus-visible {
    outline: 2px solid #409eff;
    outline-offset: 3px;
    border-radius: 8px;
}

// 按钮涟漪效果
@keyframes ripple {
    to {
        transform: scale(4);
        opacity: 0;
    }
}

.action-btn,
.el-button {
    position: relative;
    overflow: hidden;

    &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 50%;
        transform: translate(-50%, -50%) scale(0);
        pointer-events: none;
    }

    &:active::after {
        animation: ripple 0.6s ease-out;
    }
}

// 渐变文字效果
.stat-value {
    background: linear-gradient(135deg, #16a34a 0%, #0d9488 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

// 滚动条美化增强
.scroll-content {
    &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: linear-gradient(180deg, #c0c4cc 0%, #909399 100%);
        border-radius: 5px;
        border: 2px solid transparent;
        background-clip: content-box;

        &:hover {
            background: linear-gradient(180deg, #909399 0%, #606266 100%);
            background-clip: content-box;
        }

        &:active {
            background: #606266;
            background-clip: content-box;
        }
    }
}

// Popover 进入动画
:deep(.el-popper) {
    animation: popoverFadeIn 0.3s ease-out;
}

@keyframes popoverFadeIn {
    from {
        opacity: 0;
        transform: scale(0.9) translateY(-10px);
    }
    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

// 成员项悬停效果
.member-item {
    &:hover {
        .member-avatar {
            transform: scale(1.1);
        }
    }

    .member-avatar {
        transition: transform 0.3s ease;
    }
}

// 统计卡片脉冲效果
@keyframes pulse {
    0%,
    100% {
        box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.4);
    }
    50% {
        box-shadow: 0 0 0 8px rgba(102, 126, 234, 0);
    }
}

.stat-card.members-stat:hover {
    animation: pulse 1.5s ease-out;
}

// 空状态动画
@keyframes float {
    0%,
    100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-10px);
    }
}

.empty-members .empty-icon {
    animation: float 3s ease-in-out infinite;
}

// 辅助类
.text-gradient {
    background: linear-gradient(135deg, #16a34a 0%, #0d9488 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

// 卡片加载状态
.template-card.loading {
    pointer-events: none;
    opacity: 0.6;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
        animation: shimmer 1.5s infinite;
    }
}

@keyframes shimmer {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}

// 成员列表网格对齐
.members-list {
    align-items: start;
}

// 更多成员按钮（如果需要）
.more-members-btn {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    border-radius: 8px;
    background: #f0fdf4;
    color: #16a34a;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px dashed #86efac;

    &:hover {
        background: #dcfce7;
        transform: scale(1.02);
    }
}
</style>
